import React, { ReactNode, useMemo } from 'react';
import { Checkbox, Container, Text } from '@groupelacentrale/contact-storybook';
import PriorisationImage from 'assets/PublicationOptions/priorisation.png';
import PointsFortsImage from 'assets/PublicationOptions/points_forts.png';
import './PublicationOption.scss';

interface Props {
  checked: boolean;
  customPicture?: ReactNode;
  onCheck: (e: React.ChangeEvent<HTMLInputElement>) => void | undefined;
  onKeyPressCheck: (e: React.KeyboardEvent) => void | undefined;
  name: string;
  picture?: string;
  picture2?: string;
  price: number;
  estimatedPrice?: number;
  secondTitle?: string;
  text: string | ReactNode;
  title: string;
  disabled?: boolean;
}

const getImageFromPictureName = (pictureName: string) => {
  switch (pictureName) {
    case 'priorisation':
      return PriorisationImage;
    case 'points_forts':
      return PointsFortsImage;
    default:
      return undefined;
  }
};

export const PublicationOption: React.FC<Props> = ({
  checked,
  customPicture,
  onCheck,
  onKeyPressCheck,
  name,
  picture,
  picture2,
  price,
  estimatedPrice,
  secondTitle,
  text,
  title,
  disabled,
}) => {
  const promotionRate = useMemo(() => (estimatedPrice ? Math.round((1 - price / estimatedPrice) * 100) : undefined), [
    estimatedPrice,
    price,
  ]);

  return (
    <Container className="publication-option" shadowed paddings="smallP" backgroundColor="bgWhite">
      <div>
        {secondTitle && (
          <Text size="medium" weight="bold" align="center" color="quinary">
            {secondTitle}
          </Text>
        )}
        <Text size="medium" weight={secondTitle ? undefined : 'bold'} align="center">
          {title}
        </Text>
      </div>
      {customPicture && customPicture}
      {!customPicture && picture && (
        <div className={`publication-option-picture ${picture2 ? 'double' : ''}`}>
          <img src={getImageFromPictureName(picture)} alt={title} />
          {picture2 && (
            <>
              <Text size="large" weight="bold">
                +
              </Text>
              <img src={getImageFromPictureName(picture2)} alt={title} />
            </>
          )}
        </div>
      )}
      <div>{text}</div>
      <div
        className={`checkbox-wrapper ${checked && !disabled ? 'checked' : ''}`}
        tabIndex={0}
        onKeyPress={disabled ? undefined : onKeyPressCheck}
        data-option={name}
      >
        <Checkbox
          disabled={disabled}
          name={name}
          label="Sur votre annonce pendant 30 jours."
          checked={checked}
          onChange={onCheck}
        />
        <div className="publication-option-price">
          {estimatedPrice && (
            <span className="crossed">
              <Text size="medium">{estimatedPrice === 0 ? 'Gratuit' : estimatedPrice + '€'}</Text>
            </span>
          )}
          <span>
            <Text size="medium" weight="bold">
              {price === 0 ? 'Gratuit' : price + '€'}
            </Text>
          </span>
        </div>
      </div>
      {promotionRate && <div className="promotion-rate">-{promotionRate}%</div>}
    </Container>
  );
};
